import { Link } from "react-router-dom";
import "../styles/Footer.css";

function Footer() {
  return (
    <>
      <footer>
        <div className="footer-container">
          <div className="footer-content">
            <div className="footer-info">
              <h1 className="footer-title">Main Office</h1>

              <a
                className="footer-link"
                href="https://maps.app.goo.gl/q6qajtAXCZ3dsdxMA"
              >
                5465 Verna Blvd <br />
                Jacksonville, FL 32205
              </a>

              <a className="footer-link" href="mailto:info@jaxum.com">
                <span>Email:</span> info@jaxum.com
              </a>

              <a className="footer-link" href="tel:9047795353">
                <span>Tel:</span> 904-779-5353
              </a>
            </div>

            <div className="footer-info">
              <h1 className="footer-title">Quick Links</h1>

              {/* <a className="footer-link" href="#services">
                Services
              </a> */}

              <Link to="/#services" className="footer-link">
                Services
              </Link>

              <Link to="/#about-us" className="footer-link">
                About Us
              </Link>

              <Link to="Contact" className="footer-link">
                Contact
              </Link>

              <Link to="Careers" className="footer-link">
                Careers
              </Link>
            </div>

            <div className="footer-info">
              <h1 className="footer-title">Follow Us</h1>
              <div className="footer-socials">
                <a
                  className="social-icons"
                  href="https://www.linkedin.com/company/jax-utilities-management-inc/"
                  target=""
                >
                  <img src="../assets/socials/linkedin.svg" alt="LinkedIn" />
                </a>

                <a
                  className="social-icons"
                  href="https://www.facebook.com/people/Jax-Utilities-Management/61565304590230/"
                  target=""
                >
                  <img src="../assets/socials/facebook.svg" alt="Facebook" />
                </a>

                <a
                  className="social-icons"
                  href="https://www.instagram.com/jax_utilities_management/"
                  target=""
                >
                  <img src="../assets/socials/instagram.svg" alt="Instagram" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
